import DocumentPropertyService from '@/services/bytepro/documentProperty.service';

export const documentProperty = {
  namespaced: true,
  state: {
    documentProperties: {},
    loading: {},
    error: {},
  },
  getters: {
    getDocumentProperties: (state) => (fileDataId) => {
      return state.documentProperties[fileDataId] || null;
    },
    isLoading: (state) => (fileDataId) => {
      return state.loading[fileDataId] || false;
    },
    hasError: (state) => (fileDataId) => {
      return state.error[fileDataId] !== null && state.error[fileDataId] !== undefined;
    },
    getError: (state) => (fileDataId) => {
      return state.error[fileDataId] || null;
    },
  },
  actions: {
    async get({ commit, state }, fileDataId) {
      // Return cached data if available and not stale
      if (state.documentProperties[fileDataId]) {
        return Promise.resolve({ data: state.documentProperties[fileDataId], status: 200 });
      }

      commit('setLoading', { fileDataId, loading: true });
      commit('clearError', fileDataId);

      try {
        const resp = await DocumentPropertyService.get(fileDataId);
        commit('setDocumentProperties', { fileDataId, data: resp.data });
        commit('setLoading', { fileDataId, loading: false });
        commit('dummy', 'get - success');
        return Promise.resolve(resp);
      } catch (error) {
        commit('setError', { fileDataId, error: error.response });
        commit('setLoading', { fileDataId, loading: false });
        commit('dummy', 'get - error');
        return Promise.reject(error.response);
      }
    },
    clearCache({ commit }, fileDataId) {
      commit('clearDocumentProperties', fileDataId);
    },
  },
  mutations: {
    setDocumentProperties(state, { fileDataId, data }) {
      state.documentProperties = {
        ...state.documentProperties,
        [fileDataId]: data,
      };
    },
    clearDocumentProperties(state, fileDataId) {
      if (fileDataId) {
        const newProperties = { ...state.documentProperties };
        delete newProperties[fileDataId];
        state.documentProperties = newProperties;
      } else {
        state.documentProperties = {};
      }
    },
    setLoading(state, { fileDataId, loading }) {
      state.loading = {
        ...state.loading,
        [fileDataId]: loading,
      };
    },
    setError(state, { fileDataId, error }) {
      state.error = {
        ...state.error,
        [fileDataId]: error,
      };
    },
    clearError(state, fileDataId) {
      if (fileDataId) {
        const newError = { ...state.error };
        delete newError[fileDataId];
        state.error = newError;
      }
    },
    dummy(state, obj) {
      console.log(obj);
    },
  },
};
